module.exports = __webpack_public_path__ + "static/media/nu.46b0a29b.png";